import React from 'react';
import { MdOutlineExtension } from 'react-icons/md';

import { Box, Card, Flex, Grid, Tag, Text } from 'core/components';
import { useTheme } from 'styled-components';
import AddOnCardExtensions, { ExtensionsText } from './AddOnCardExtensions';

type AddOnCardProps = {
  title: string;
  description: string;
  extensions?: ExtensionsText[];
  zIndex: number;
};

const AddOnCard = ({ title, description, extensions = [], zIndex }: AddOnCardProps) => {
  const theme = useTheme();
  const isDarkMode = theme.name === 'dark';
  const contentColor = isDarkMode ? theme.colors.whiteMuted : theme.colors.muted;

  return (
    <Card
      p={2}
      pt={4}
      bg={theme.colors.sectionBackground}
      borderRadius={8}
      mt="-16px"
      position="relative"
      zIndex={zIndex}
    >
      <Grid gridTemplateColumns="2fr 1fr" gridTemplateRows="1fr">
        <Box>
          <Flex>
            <Flex flexDirection="column" mr={3} justifyContent="center" alignItems="center">
              <MdOutlineExtension size={20} color={theme.colors.primary} />
            </Flex>
            <Flex flexDirection="column">
              <Box mb={1}>
                <Text as="span" color={contentColor} fontWeight={500}>
                  {title}
                </Text>
                {/* @ts-expect-error to bypass TS errors for the JS <Tag> component until TODO to convert <Tag> component is complete */}
                <Tag ml={1} color={contentColor} fontSize={12} p="2px 6px" borderRadius={4}>
                  Add-On
                </Tag>
              </Box>
              <Text as="div" fontSize={18} fontWeight="bold">
                {description}
              </Text>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Text as="div" mb={1}>
            Extensions
          </Text>
          <AddOnCardExtensions extensions={extensions} />
        </Box>
      </Grid>
    </Card>
  );
};

export default AddOnCard;
